<script lang="ts">
  import { api } from '../../api/client';
  import type { Member, PlaceEvent } from '../../api/types';
  import { eventIcon, eventText } from '../../utils/events';
  import { when } from '../../utils/time';
  import { t } from '../../i18n/index.ts';

  // PlaceHistory lists recent arrivals, departures, and trips that ended at
  // one place. The parent bumps refresh when a new event arrives over the
  // socket.
  let { groupId, placeId, members, refresh }: {
    groupId: string;
    placeId: string;
    members: Member[];
    refresh: number;
  } = $props();

  let events: PlaceEvent[] = $state([]);
  let error = $state('');

  $effect(() => {
    const url = `/groups/${groupId}/events?place_id=${placeId}&limit=50`;
    void refresh;
    api.get<PlaceEvent[]>(url)
      .then((list) => { events = list; error = ''; })
      .catch((e: any) => (error = e.message));
  });

  function name(userId: string): string {
    return members.find((m) => m.user_id === userId)?.display_name ?? t('componentsPlaceHistoryFormerMember');
  }
</script>

{#if error}
  <p class="text-sm" style="color: var(--theme-error);">{error}</p>
{:else if events.length === 0}
  <p class="text-sm text-text-muted">{t('componentsPlaceHistoryEmpty')}</p>
{:else}
  <ul class="space-y-1 text-sm">
    {#each events as e (e.id)}
      <li class="flex justify-between gap-2">
        <span><i aria-hidden="true" class="las {eventIcon(e)} mr-1"></i>{name(e.user_id)} {eventText(e)}</span>
        <span class="text-text-muted shrink-0" title={e.late ? t('componentsPlaceHistoryLateTitle') : ''}>
          {e.late ? t('componentsPlaceHistoryWhenLate', { when: when(e.occurred_at) }) : when(e.occurred_at)}
        </span>
      </li>
    {/each}
  </ul>
{/if}
